const BurgerMenuExpandedIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.2806 26.2194C27.3502 26.2891 27.4055 26.3718 27.4432 26.4628C27.4809 26.5539 27.5003 26.6515 27.5003 26.75C27.5003 26.8485 27.4809 26.9461 27.4432 27.0372C27.4055 27.1282 27.3502 27.2109 27.2806 27.2806C27.2109 27.3503 27.1281 27.4056 27.0371 27.4433C26.9461 27.481 26.8485 27.5004 26.7499 27.5004C26.6514 27.5004 26.5538 27.481 26.4628 27.4433C26.3717 27.4056 26.289 27.3503 26.2193 27.2806L19.9999 21.0603L13.7806 27.2806C13.6398 27.4214 13.449 27.5004 13.2499 27.5004C13.0509 27.5004 12.86 27.4214 12.7193 27.2806C12.5786 27.1399 12.4995 26.949 12.4995 26.75C12.4995 26.551 12.5786 26.3601 12.7193 26.2194L18.9396 20L12.7193 13.7806C12.5786 13.6399 12.4995 13.449 12.4995 13.25C12.4995 13.051 12.5786 12.8601 12.7193 12.7194C12.86 12.5786 13.0509 12.4996 13.2499 12.4996C13.449 12.4996 13.6398 12.5786 13.7806 12.7194L19.9999 18.9397L26.2193 12.7194C26.36 12.5786 26.5509 12.4996 26.7499 12.4996C26.949 12.4996 27.1398 12.5786 27.2806 12.7194C27.4213 12.8601 27.5003 13.051 27.5003 13.25C27.5003 13.449 27.4213 13.6399 27.2806 13.7806L21.0602 20L27.2806 26.2194Z"
        fill="#424242"
      />
    </svg>
  );
};

export default BurgerMenuExpandedIcon;
